


























































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Search, SortDirection } from '@/data/models/search.model';
import { PeriodicService } from '@/data/models/periodicservice.model';

@Component
export default class ServizioPeriodicoList extends Vue {
	@Prop({ default: false }) checkboxable!: boolean;
	@Prop({ default: false }) selectable!: boolean;

	@Inject('CrudService') crudService!: CrudService<PeriodicService>;

	rows: PeriodicService[] = [];
	loading: boolean = false;

	advancedSearch: Search = new Search('periodicservice');

	checkedRows: PeriodicService[] = [];

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	load() {
		this.checkedRows = [];

		const datareq = this.crudService.searchEntities(
			PeriodicService,
			'periodicservice',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			PeriodicService,
			'periodicservice',
			this.advancedSearch
		);
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	deleteServizioPeriodico(item: PeriodicService) {
		this.$emit('delete', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.load();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.load();
	}

	onCheck(checked: PeriodicService[]) {
		this.$emit('update:selected', checked);
	}
}
